import axios from "axios";
// import store from '../store';

function errorHandler(error, reject) {
  console.log(error);
  if (error.response && error.response.data) {
    reject(error.response.data);
  } else {
    reject(error);
  }
}

export default {
  pnl(obj) {
    return new Promise(async (resolve, reject) => {
      try {
        const keys = ["layout", "tgl1", "tgl2", "excludekosong"];
        let str = "";
        for (const key in obj) {
          if (keys.indexOf(key) >= 0 && obj[key]) {
            str += str ? "&" : "?";
            str += key + "=" + encodeURIComponent(obj[key]);
          }
        }
        const url = `/incomestat/pnl${str}`;
        const { data } = await axios.get(url);
        resolve(data[0]);
      } catch (error) {
        errorHandler(error, reject);
      }
    });
  },
  pnlprint(obj = {}) {
    return new Promise(async (resolve, reject) => {
      try {
        const keys = ["layout", "tgl1", "tgl2", "excludekosong"];

        let str = "?";
        if (obj.tabIndex === 0) {
          str += "view=" + encodeURIComponent("summary");
        } else {
          str += "view=" + encodeURIComponent("current");
        }
        for (const key in obj) {
          if (keys.indexOf(key) >= 0 && obj[key]) {
            str += str ? "&" : "?";
            str += key + "=" + encodeURIComponent(obj[key]);
          }
        }

        const url = `/incomestat/pnlprint${str}`;
        const { data } = await axios.get(url);
        console.log("data : ", data);
        const link = `${process.env.VUE_APP_BASE_API}/printpreview/pdf/${data.id}`;
        resolve(link);
      } catch (error) {
        errorHandler(error, reject);
      }
    });
  },
  pnlexport(obj = {}) {
    return new Promise(async (resolve, reject) => {
      try {
        const keys = ["layout", "tgl1", "tgl2", "excludekosong"];
        let str = "";
        for (const key in obj) {
          if (keys.indexOf(key) >= 0 && obj[key]) {
            str += str ? "&" : "?";
            str += key + "=" + encodeURIComponent(obj[key]);
          }
        }

        let response = await axios({
          url: `/incomestat/pnlexport${str}`,
          method: "GET",
          responseType: "blob", // important
        });
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `income_statement_${obj.tgl2}.xlsx`);
        document.body.appendChild(link);
        link.click();
        resolve(link);
      } catch (error) {
        let responseObj = await error.response.data.text();
        errorHandler(JSON.parse(responseObj), reject);
      }
    });
  },
  pnldim1(obj) {
    return new Promise(async (resolve, reject) => {
      try {
        const keys = ["DimCol", "DimVal", "layout", "tgl1", "tgl2"];
        let str = "";
        for (const key in obj) {
          if (keys.indexOf(key) >= 0 && obj[key]) {
            str += str ? "&" : "?";
            str += key + "=" + encodeURIComponent(obj[key]);
          }
        }
        const url = `/incomestat/pnldim1${str}`;
        const { data } = await axios.get(url);
        resolve(data[0]);
      } catch (error) {
        errorHandler(error, reject);
      }
    });
  },
  pnldim1print(obj = {}) {
    return new Promise(async (resolve, reject) => {
      try {
        const keys = [
          "DimCol",
          "DimVal",
          "DimColInfo",
          "DimValInfo",
          "layout",
          "tgl1",
          "tgl2",
        ];
        let str = "?";
        if (obj.tabIndex === 0) {
          str += "view=" + encodeURIComponent("summary");
        } else {
          str += "view=" + encodeURIComponent("current");
        }
        for (const key in obj) {
          if (keys.indexOf(key) >= 0 && obj[key]) {
            str += str ? "&" : "?";
            str += key + "=" + encodeURIComponent(obj[key]);
          }
        }

        const url = `/incomestat/pnldim1print${str}`;
        const { data } = await axios.get(url);
        const link = `${process.env.VUE_APP_BASE_API}/printpreview/pdf/${data.id}`;
        resolve(link);
      } catch (error) {
        errorHandler(error, reject);
      }
    });
  },
  pnldim1export(obj = {}) {
    return new Promise(async (resolve, reject) => {
      try {
        const keys = [
          "DimCol",
          "DimVal",
          "DimColInfo",
          "DimValInfo",
          "layout",
          "tgl1",
          "tgl2",
        ];
        let str = "";
        for (const key in obj) {
          if (keys.indexOf(key) >= 0 && obj[key]) {
            str += str ? "&" : "?";
            str += key + "=" + encodeURIComponent(obj[key]);
          }
        }

        let response = await axios({
          url: `/incomestat/pnldim1export${str}`,
          method: "GET",
          responseType: "blob", // important
        });
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `pnl_dimension_${obj.tgl2}.xlsx`);
        document.body.appendChild(link);
        link.click();
        resolve(link);
      } catch (error) {
        let responseObj = await error.response.data.text();
        errorHandler(JSON.parse(responseObj), reject);
      }
    });
  },
  pnldim10(obj) {
    obj.modeGet = "view";
    return new Promise(async (resolve, reject) => {
      try {
        const keys = [
          "DimCol",
          "DimColInfo",
          "layout",
          "tgl1",
          "tgl2",
          "DimLimit",
          "sortBy",
          "modeGet",
        ];
        let str = "";
        for (const key in obj) {
          if (keys.indexOf(key) >= 0 && obj[key]) {
            str += str ? "&" : "?";
            str += key + "=" + encodeURIComponent(obj[key]);
          }
        }
        const url = `/incomestat/pnldim10${str}`;
        const { data } = await axios.get(url);
        resolve(data);
      } catch (error) {
        errorHandler(error, reject);
      }
    });
  },
  pnldim10print(obj = {}) {
    obj.modeGet = "view";
    return new Promise(async (resolve, reject) => {
      try {
        const keys = [
          "DimCol",
          "DimColInfo",
          "layout",
          "tgl1",
          "tgl2",
          "DimLimit",
          "sortBy",
          "modeGet",
        ];
        let str = "";
        for (const key in obj) {
          if (keys.indexOf(key) >= 0 && obj[key]) {
            str += str ? "&" : "?";
            str += key + "=" + encodeURIComponent(obj[key]);
          }
        }

        const url = `/incomestat/pnldim10${str}`;
        const { data } = await axios.get(url);
        const link = `${process.env.VUE_APP_BASE_API}/printpreview/pdf/${data.id}`;
        resolve(link);
      } catch (error) {
        errorHandler(error, reject);
      }
    });
  },
  pnldim10export(obj = {}) {
    obj.modeGet = "exportxls";
    return new Promise(async (resolve, reject) => {
      try {
        const keys = [
          "DimCol",
          "DimColInfo",
          "layout",
          "tgl1",
          "tgl2",
          "DimLimit",
          "sortBy",
          "modeGet",
        ];
        let str = "";
        for (const key in obj) {
          if (keys.indexOf(key) >= 0 && obj[key]) {
            str += str ? "&" : "?";
            str += key + "=" + encodeURIComponent(obj[key]);
          }
        }

        let response = await axios({
          url: `/incomestat/pnldim10${str}`,
          method: "GET",
          responseType: "blob", // important
        });
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `pnl_${obj.DimColInfo}_${obj.tgl2}.xlsx`);
        document.body.appendChild(link);
        link.click();
        resolve(link);
      } catch (error) {
        let responseObj = await error.response.data.text();
        errorHandler(JSON.parse(responseObj), reject);
      }
    });
  },
  pnldimanalys(obj) {
    return new Promise(async (resolve, reject) => {
      try {
        const keys = [
          "DimRow",
          "DimRowInfo",
          "DimCol",
          "DimColInfo",
          "layout",
          "tgl1",
          "tgl2",
        ];
        let str = "";
        for (const key in obj) {
          if (keys.indexOf(key) >= 0 && obj[key]) {
            str += str ? "&" : "?";
            str += key + "=" + encodeURIComponent(obj[key]);
          }
        }
        const url = `/incomestat/pnldimanalys${str}`;
        const { data } = await axios.get(url);
        resolve(data);
      } catch (error) {
        errorHandler(error, reject);
      }
    });
  },
  pnldimanalysprint(obj = {}) {
    return new Promise(async (resolve, reject) => {
      try {
        const keys = [
          "DimRow",
          "DimRowInfo",
          "DimCol",
          "DimColInfo",
          "layout",
          "tgl1",
          "tgl2",
        ];
        let str = "";
        for (const key in obj) {
          if (keys.indexOf(key) >= 0 && obj[key]) {
            str += str ? "&" : "?";
            str += key + "=" + encodeURIComponent(obj[key]);
          }
        }

        const url = `/incomestat/pnldimanalysprint${str}`;
        const { data } = await axios.get(url);
        const link = `${process.env.VUE_APP_BASE_API}/printpreview/pdf/${data.id}`;
        resolve(link);
      } catch (error) {
        errorHandler(error, reject);
      }
    });
  },
  pnldimanalysexport(obj = {}) {
    return new Promise(async (resolve, reject) => {
      try {
        const keys = [
          "DimRow",
          "DimRowInfo",
          "DimCol",
          "DimColInfo",
          "layout",
          "tgl1",
          "tgl2",
        ];
        let str = "";
        for (const key in obj) {
          if (keys.indexOf(key) >= 0 && obj[key]) {
            str += str ? "&" : "?";
            str += key + "=" + encodeURIComponent(obj[key]);
          }
        }

        let response = await axios({
          url: `/incomestat/pnldimanalysexport${str}`,
          method: "GET",
          responseType: "blob", // important
        });
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          `pnl_Analysis_dimension_${obj.tgl2}.xlsx`
        );
        document.body.appendChild(link);
        link.click();
        resolve(link);
      } catch (error) {
        let responseObj = await error.response.data.text();
        errorHandler(JSON.parse(responseObj), reject);
      }
    });
  },
  layout(obj) {
    return new Promise(async (resolve, reject) => {
      try {
        // const { data } = await axios.get(`incomestat/layout/${encodeURIComponent(obj.layout)}`);
        const { data } = await axios.get(`incomestatfmt/${encodeURIComponent(obj.layout)}`);
        resolve(data);
      } catch (error) {
        errorHandler(error, reject);
      }
    });
  },
  layout_combo() {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await axios.get(`incomestatfmt/combo`);
        resolve(data);
      } catch (error) {
        errorHandler(error, reject);
      }
    });
  },
  layoutDel(obj) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await axios.delete(`incomestatfmt/${encodeURIComponent(obj.layout)}`);
        resolve(data);
      } catch (error) {
        errorHandler(error, reject);
      }
    });
  },
  layoutSave(data) {
    return new Promise(async (resolve, reject) => {
      try {
        await axios.post("incomestatfmt", data);
        resolve();
      } catch (error) {
        errorHandler(error, reject);
      }
    });
  },
  detailtrx(obj) {
    obj.modeGet = "view";
    return new Promise(async (resolve, reject) => {
      try {
        const keys = [
          "kodeaw",
          "tgl1",
          "tgl2",
          "DimCol",
          "DimVal",
          "DimColInfo",
          "DimValInfo",
          "modeGet",
        ];
        let str = "";
        for (const key in obj) {
          if (keys.indexOf(key) >= 0 && obj[key]) {
            str += str ? "&" : "?";
            str += key + "=" + encodeURIComponent(obj[key]);
          }
        }
        const url = `/incomestat/dimdetailtrx${str}`;
        const { data } = await axios.get(url);
        // console.log('data.tb : ', data[1]);
        resolve(data[0]);
      } catch (error) {
        errorHandler(error, reject);
      }
    });
  },
  detailtrxprint(obj = {}) {
    obj.modeGet = "print";
    return new Promise(async (resolve, reject) => {
      try {
        const keys = [
          "kodeaw",
          "tgl1",
          "tgl2",
          "DimCol",
          "DimVal",
          "DimColInfo",
          "DimValInfo",
          "modeGet",
        ];
        let str = "?";
        for (const key in obj) {
          if (keys.indexOf(key) >= 0 && obj[key]) {
            str += str ? "&" : "?";
            str += key + "=" + encodeURIComponent(obj[key]);
          }
        }

        const url = `/incomestat/dimdetailtrx${str}`;
        const { data } = await axios.get(url);
        // console.log('data : ', data);
        const link = `${process.env.VUE_APP_BASE_API}/printpreview/pdf/${data.id}`;
        resolve(link);
      } catch (error) {
        errorHandler(error, reject);
      }
    });
  },
  detailtrxexport(obj = {}) {
    obj.modeGet = "exportxls";
    return new Promise(async (resolve, reject) => {
      try {
        const keys = [
          "kodeaw",
          "tgl1",
          "tgl2",
          "DimCol",
          "DimVal",
          "DimColInfo",
          "DimValInfo",
          "modeGet",
        ];
        let str = "";
        for (const key in obj) {
          if (keys.indexOf(key) >= 0 && obj[key]) {
            str += str ? "&" : "?";
            str += key + "=" + encodeURIComponent(obj[key]);
          }
        }

        let response = await axios({
          url: `/incomestat/dimdetailtrx${str}`,
          method: "GET",
          responseType: "blob", // important
        });
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `Dimension_detailTrx_${obj.tgl2}.xlsx`);
        document.body.appendChild(link);
        link.click();
        resolve(link);
      } catch (error) {
        let responseObj = await error.response.data.text();
        errorHandler(JSON.parse(responseObj), reject);
      }
    });
  },
};
